export default __webpack_public_path__ + "static/electricite-9a41b7b884bdd94e7f154b048e414951.jpg";